import { render, staticRenderFns } from "./no-tasks.vue?vue&type=template&id=237ab180&scoped=true&"
import script from "./no-tasks.vue?vue&type=script&lang=js&"
export * from "./no-tasks.vue?vue&type=script&lang=js&"
import style0 from "./no-tasks.vue?vue&type=style&index=0&id=237ab180&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237ab180",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
